// extracted by mini-css-extract-plugin
export var item = "Item-module--item--3dkh3";
export var item__title = "Item-module--item__title--LSxVd";